import React, { useState, useEffect } from "react";
import "./message.scss";

import { LazyLoadImage } from "react-lazy-load-image-component";

/* REDUX */
import { useSelector, useDispatch } from "react-redux";
import { showGallery, showModal, setMessage } from "../../redux/actions";

/* ASSETS */
import moment from "moment";
import axios from "axios";
import IconExcel from "../../assets/excel-icon.png";
import IconWord from "../../assets/word-icon.png";
import IconPdf from "../../assets/pdf-icon.svg";
import EmojiPencil from "../../assets/94.png";
import EmojiThumb from "../../assets/435.png";
import EmojiWarning from "../../assets/71.png";
import EmojiError from "../../assets/820.png";
import { toast } from "react-toastify";

const Message = ({
  reference,
  msg,
  text,
  file,
  date,
  state,
  deleteMessage,
  likeMessage,
}) => {
  const [author, setAuthor] = useState({
    title: "",
    firstname: "",
    lastname: "",
    tag: "",
    picture: "",
  });
  const [loaded, setLoaded] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;

    axios
      .get(`/api/v1/users/user/${msg.author.authorID}`)
      .then((res) => {
        if (mounted) {
          res.data
            ? setAuthor(res.data)
            : setAuthor({ firstname: "Inaktives", lastname: "Konto" });
        }
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoaded(true));

    // CLEANUP
    return () => (mounted = false);
  }, []);

  const report = async () => {
    const payload = {
      reportID: msg.author.authorID,
      messageID: msg._id,
    };

    try {
      // SET AUTH HEADER
      axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
        "kzvb-obleute"
      );

      await axios.post("/api/v1/users/report", payload);
      toast.warning(
        `Beitrag von ${author.firstname} ${author.lastname} wurde gemeldet.`
      );
    } catch (err) {
      console.log(err.response);
      if (err.response && err.response.data)
        err.response.data.map((message) => toast.error(message.msg));
      else {
        toast.error(err.message);
      }
    }
  };

  const defineExtension = () => {
    const ext = file.url.split(".")[1];

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        return "image";
      case "xls":
      case "xlsx":
        return "excel";
      case "doc":
      case "docx":
        return "word";
      case "pdf":
        return "pdf";
      default:
        return;
    }
  };

  return (
    <React.Fragment>
      {loaded ? (
        <figure
          ref={reference}
          className={`message${author.tag === user.data.tag ? "--author" : ""}`}
        >
          <div className='message__user'>
            {author && author.picture ? (
              <div className='message__user__image'>
                <LazyLoadImage
                  src={`${
                    process.env.NODE_ENV === "production"
                      ? window.location.origin
                      : "http://localhost:8000"
                  }/${author.picture.url}`}
                  alt=''
                />
              </div>
            ) : (
              <div className='message__user__icon'>
                <span>
                  {author.firstname.charAt(0)}
                  {author.lastname.charAt(0)}
                </span>
              </div>
            )}
          </div>
          <div className='message__body'>
            <div className='message__header'>
              <span className='message__header__name'>
                {author.title && author.title} {author.firstname}{" "}
                {author.lastname}
              </span>
              <span className='message__header__date'>
                {moment(date).format("HH:mm - DD.MM")}
              </span>
            </div>
            <div className='message__content'>
              {state === 0 ? (
                <React.Fragment>
                  {file && defineExtension() === "image" && (
                    <div
                      className='message__content__file'
                      onClick={() => dispatch(showGallery(file.url))}
                    >
                      <LazyLoadImage
                        src={`${
                          process.env.NODE_ENV === "production"
                            ? window.location.origin
                            : "http://localhost:8000"
                        }/${file.url}`}
                        alt=''
                      />
                    </div>
                  )}
                  {file && defineExtension() === "excel" && (
                    <div
                      className='message__content__file--small'
                      onClick={() =>
                        window.open(
                          `${
                            process.env.NODE_ENV === "production"
                              ? window.location.origin
                              : "http://localhost:8000"
                          }/${file.url}`,
                          "_blank"
                        )
                      }
                    >
                      <LazyLoadImage
                        src={IconExcel}
                        alt='Microsoft Excel File'
                      />
                      <span>{file.name}</span>
                    </div>
                  )}
                  {file && defineExtension() === "word" && (
                    <div
                      className='message__content__file--small'
                      onClick={() =>
                        window.open(
                          `${
                            process.env.NODE_ENV === "production"
                              ? window.location.origin
                              : "http://localhost:8000"
                          }/${file.url}`,
                          "_blank"
                        )
                      }
                    >
                      <LazyLoadImage src={IconWord} alt='Microsoft Word File' />
                      <span>{file.name}</span>
                    </div>
                  )}
                  {file && defineExtension() === "pdf" && (
                    <div
                      className='message__content__file--small'
                      onClick={() =>
                        window.open(
                          `${
                            process.env.NODE_ENV === "production"
                              ? window.location.origin
                              : "http://localhost:8000"
                          }/${file.url}`,
                          "_blank"
                        )
                      }
                    >
                      <LazyLoadImage src={IconPdf} alt='Adobe PDF' />
                      <span>{file.name}</span>
                    </div>
                  )}
                  <p className='message__content__text'>{text}</p>
                  {msg.edited && (
                    <p className='message__content__edit'>
                      <span className='icon icon--pencil mr-2'></span>
                      <span>bearbeitet</span>
                    </p>
                  )}
                </React.Fragment>
              ) : (
                <span className='message__content__text--delete'>
                  Nachricht wurde gelöscht
                </span>
              )}
            </div>
            {state === 0 && (
              <div className='message__actions'>
                <div className='message__actions__item' onClick={likeMessage}>
                  <img src={EmojiThumb} alt='' />
                </div>
                {author.tag !== user.data.tag && (
                  <div
                    className='message__actions__item'
                    onClick={() => report()}
                  >
                    <img src={EmojiWarning} alt='' />
                  </div>
                )}
                {author.tag === user.data.tag && (
                  <div
                    className='message__actions__item'
                    onClick={() => {
                      dispatch(setMessage(msg));
                      dispatch(
                        showModal("Nachricht bearbeiten", "message-edit")
                      );
                    }}
                  >
                    <img src={EmojiPencil} alt='' />
                  </div>
                )}
                {(author.tag === user.data.tag || user.data.admin) && (
                  <div
                    className='message__actions__item'
                    onClick={deleteMessage}
                  >
                    <img src={EmojiError} alt='' />
                  </div>
                )}
              </div>
            )}
          </div>
          {msg.likes.length > 0 && (
            <div className='message__reactions'>
              <span>{msg.likes.length}</span>
              <img src={EmojiThumb} alt='Like' />
            </div>
          )}
        </figure>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default Message;
